























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class GridSection extends Vue {
  @Prop({ default: () => ({}) }) readonly promotionInfo!: any

  clickMore() {
    this.$emit('track-click', { clickId: '200034' })
    location.href = this.promotionInfo.showMoreUrl
  }

  clickProduct(product: any) {
    this.$emit('track-click', { clickId: '200033', name: product.spuName })
    if (product.type) {
      if (product.type === 1) {
        if (product.templateType2Id === 601) {
          location.href = `https://life.cekid.com/v2/ticket/detail/${product.spuId}?kwtarget=blank&module=1`
        } else {
          location.href = `https://life.cekid.com/v/product/${product.spuId}?kwtarget=blank&module=1`
        }
      } else if (product.type === 2) {
        location.href = `https://w.cekid.com/child-card/recharge?skuId=${product.spuId}&storeCode=${product.storeId}&kwtarget=blank&module=1`
      } else if (product.type === 3) {
        location.href = `https://w.cekid.com/interaction-activity/detail/${product.spuId}?kwtarget=blank&module=1`
      } else {
        if (product.linkUrl) {
          location.href = product.linkUrl.indexOf('?') > -1 ? `${product.linkUrl}&kwtarget=blank&module=1` : `${product.linkUrl}?kwtarget=blank&module=1`
        }
      }
    }
  }

  getTags(item: any) {
    const tags = []
    if (item.promotions) {
      const info = JSON.parse(item.promotions)
      if (info.promotion1 && info.promotion1.length > 0) {
        tags.push(info.promotion1[0])
      }
      if (info.promotion2 && info.promotion2.length > 0) {
        tags.push(info.promotion2[0])
      }
    }
    if (item.categorySellPoint && tags.length === 0) {
      tags.push(item.categorySellPoint)
    }
    return tags
  }
}
